document.addEventListener('DOMContentLoaded', () => {
    document.addEventListener('click', (event) => {
        const button = event.target.closest('.prevent-double-click');

        if (button) {
            // Prevent repeated clicks
            if (button.dataset.disabled === 'true' || button.disabled) {
                event.preventDefault();
                return;
            }

            const form = button.closest('form');

            // Handle buttons inside forms
            if (form) {
                // Validate the form before proceeding
                if (!form.checkValidity()) {
                    form.reportValidity(); // Show validation messages
                    return;
                }

                // Disable the button and add spinner
                button.dataset.disabled = 'true';
                button.disabled = true;
                button.classList.add('disabled');
                button.dataset.originalHtml = button.innerHTML;
                button.innerHTML = `<i class="fa fa-spinner fa-spin"></i> ${button.innerText}`;

                // Submit the form explicitly
                form.submit();
            }

            // Handle <a> tags
            if (button.tagName === 'A' && button.href) {
                event.preventDefault(); // Prevent default click
                button.dataset.disabled = 'true';
                button.classList.add('disabled');
                button.innerHTML = `<i class="fa fa-spinner fa-spin"></i> ${button.innerText}`;

                setTimeout(() => {
                    window.location.href = button.href;
                }, 300); // Delay for spinner visibility
            }
        }
    });
});
